var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loading"},[(!_vm.show)?_c('span',[_vm._t("default")],2):_c('b-spinner',{attrs:{"small":_vm.small,"variant":_vm.$setup.theme == 'dark' ? 'primary' : 'light'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }